import IconTextFile from '@mnd-frontend/icons/components/TextFile';
import { GREY_200, GREY_400, NEUTRAL_WHITE, SPACING_1_5 } from '@mnd-frontend/ui/shared/tokens';
import styled, { keyframes } from 'styled-components';
import { ReactComponent as Corner } from './corner.svg?react';

const fadeIn = keyframes`
  from {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
`;

const Base = styled.div<{ $imageUrl?: string }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  animation: ${fadeIn} 0.4s ease-in;
  background-image: ${({ $imageUrl }) => ($imageUrl ? `url(${$imageUrl})` : 'none')};
`;

const ImageWrapper = styled.div<{ $isVideo?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  ${({ $isVideo }) => $isVideo && 'background-color: #020202;'};

  > span {
    z-index: 1;
  }
`;

const Image = styled(Base)`
  background-color: ${GREY_400};
`;

const Video = styled(Base)`
  background-color: ${GREY_400};
  margin: ${SPACING_1_5} 0;
`;

const Document = styled(Base)`
  -webkit-clip-path: polygon(0 0, 0 100%, 100% 100%, 100% 13%, 88% 0);
  clip-path: polygon(0 0, 0 100%, 100% 100%, 100% 13%, 88% 0);
  background-color: "transparent";
`;

const DocumentCorner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
`;

const PlayIcon = styled.i`
  z-index: 1;
`;

const DocumentBackground = styled(Base)<{ $noOverlay?: boolean }>`
  background-color: ${({ $noOverlay }) => ($noOverlay ? NEUTRAL_WHITE : GREY_200)};
  opacity: 0.6;
  -webkit-clip-path: polygon(0 0, 0 100%, 100% 100%, 100% 13%, 88% 0);
  clip-path: polygon(0 0, 0 100%, 100% 100%, 100% 13%, 88% 0);
  z-index: ${({ $noOverlay }) => ($noOverlay ? 0 : 1)};
  animation: none;
`;

const MediaCardView = ({
  type,
  image,
  noOverlay,
}: {
  type?: string;
  image?: { url?: string };
  noOverlay?: boolean;
}) => {
  if (type === 'Image') {
    return (
      <ImageWrapper>
        <Image $imageUrl={image?.url} />
      </ImageWrapper>
    );
  } else if (type === 'Video') {
    return (
      <ImageWrapper $isVideo>
        <Video $imageUrl={image?.url} />
        <PlayIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM16 14.9976C15.979 13.5873 16.2776 13.4229 17.5 13.9976L35.5 22.9976C37.206 23.854 36.9874 24.285 35.5 24.9976L17.5 33.9976C16.3089 34.4869 15.9539 34.0771 16 32.4976V14.9976Z"
              fill="white"
              fillOpacity="0.75"
            />
          </svg>
        </PlayIcon>
      </ImageWrapper>
    );
  }

  return (
    <ImageWrapper>
      <DocumentCorner>
        <Corner />
      </DocumentCorner>
      <DocumentBackground $noOverlay={noOverlay} />
      {image?.url ? (
        <Document $imageUrl={image.url} />
      ) : (
        <IconTextFile $color="GREY_900" $size="md" />
      )}
    </ImageWrapper>
  );
};

export default MediaCardView;
